export default __webpack_public_path__ + "static/logo-elettrico-0c27d8a72cf06d729104890bde1bad2a.svg";